// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"4498c8a6","787":"c5712501","921":"f44c52dc"}[chunkId] + ".chunk.js";
};